import App from './App'
import { createSSRApp } from 'vue'
import * as Pinia from 'pinia'
import '@/el-ui/index.js'
import config from '@/config/index.js'
import i18n from './locale/index.js'


uni.$config.set(config);
export function createApp() {
  const app = createSSRApp(App)
  app.use(Pinia.createPinia())
  app.use(i18n)
  return {
    app,
	Pinia
  }
}